// inicializa el componente SuscripcionExtraordinaria
import suscripcionTabs from "../suscripcion/gestor_suscripcion.vue";
import CryptoJS from "crypto-js";
export default {
    components: { suscripcionTabs },
    name: 'suscripcionExtraordinaria',
    data() {
        return {
            suscripcion: null,
            usuario: null,
        };
    },

    created() {
        // Log
        console.log('SuscripcionExtraordinaria created');
    },


    mounted() {
        let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
        if (informacion_incriptada != null) {
            let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
            let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
            let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
            let r = JSON.parse(informacion_desincriptada)
            this.usuario = r.usuario[0]
            this.suscripcion = r.suscripcion
            console.log("usuario log", this.usuario);
        }
    },

};